import * as types from './types'

export default {
  [types.ADD_VIDEO](state, video) {
    state.videos.push(video)
  },
  [types.SET_VIDEOS](state, videos) {
    state.videos = videos || []
  },
  [types.DELETE_VIDEO](state, video) {
    state.videos.splice(state.videos.indexOf(video), 1)
  },
  [types.SET_MARKET_SEGMENTS](state, marketSegments) {
    state.marketSegments = marketSegments || []
  },
  [types.SET_INCOMPLETE_VIDEOS_COUNT](state, count) {
    state.incompleteVideosCount = count
  },
  [types.UPDATE_INCOMPLETE_VIDEOS_COUNT](state, count) {
    state.incompleteVideosCount += count
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/video/mutations.js